import React, { useState, useEffect } from 'react';
import { playThemeSound } from '../../../utils/themeAudio';

const LANTERN_ITEMS = [
    { type: 'lantern', color: '#f59e0b', glow: 'rgba(245, 158, 11, 0.7)' },
    { type: 'kandil', color: '#e11d48', glow: 'rgba(225, 29, 72, 0.7)' },
    { type: 'gold', color: '#fbbf24', glow: 'rgba(251, 191, 36, 0.8)' },
    { type: 'purple', color: '#9333ea', glow: 'rgba(147, 51, 234, 0.7)' },
];

const DIWALI_CHIMES = ['SHUBH DIWALI! 🪔', 'LIGHT & PROSPERITY! ✨', 'SACRED GLOW! ⭐', 'VICTORY OF LIGHT! 🎆'];

const FloatingSkyLanterns = () => {
    const [lanterns, setLanterns] = useState([]);
    const [blessings, setBlessings] = useState([]);

    useEffect(() => {
        const initial = Array.from({ length: 18 }).map((_, i) => ({
            id: i,
            spec: LANTERN_ITEMS[i % LANTERN_ITEMS.length],
            left: Math.random() * 95,
            delay: Math.random() * 6,
            duration: 9 + Math.random() * 7,
            scale: 0.8 + Math.random() * 0.45,
            popped: false
        }));
        setLanterns(initial);
    }, []);

    const handleLanternClick = (l, e) => {
        e.stopPropagation();
        playThemeSound('diwali', 'sparkle');

        const rect = e.currentTarget.getBoundingClientRect();
        const effectId = Date.now() + Math.random();
        const text = DIWALI_CHIMES[Math.floor(Math.random() * DIWALI_CHIMES.length)];

        setBlessings(prev => [...prev, {
            id: effectId,
            x: rect.left,
            y: rect.top,
            text
        }]);

        setTimeout(() => {
            setBlessings(prev => prev.filter(item => item.id !== effectId));
        }, 1200);

        setLanterns(prev => prev.map(item => {
            if (item.id === l.id) return { ...item, popped: true };
            return item;
        }));

        setTimeout(() => {
            setLanterns(prev => prev.map(item => {
                if (item.id === l.id) {
                    return {
                        ...item,
                        popped: false,
                        left: Math.random() * 95,
                        delay: 0,
                        duration: 9 + Math.random() * 7
                    };
                }
                return item;
            }));
        }, 3200);
    };

    return (
        <div className="fixed inset-0 pointer-events-none z-[61] overflow-hidden select-none">
            {/* Pop Blessing Floating text */}
            {blessings.map((eff) => (
                <div
                    key={eff.id}
                    className="fixed text-xs md:text-sm font-extrabold text-amber-300 drop-shadow-[0_2px_8px_rgba(245,158,11,0.9)] animate-float-up pointer-events-none z-[75]"
                    style={{ left: eff.x, top: eff.y }}
                >
                    {eff.text}
                </div>
            ))}

            {/* Floating Sky Lanterns */}
            {lanterns.map((l) => {
                if (l.popped) return null;
                return (
                    <div
                        key={l.id}
                        onClick={(e) => handleLanternClick(l, e)}
                        onTouchStart={(e) => handleLanternClick(l, e)}
                        className="absolute bottom-[-90px] animate-float-up pointer-events-auto cursor-pointer hover:scale-130 transition-transform"
                        style={{
                            left: `${l.left}%`,
                            animationDelay: `${l.delay}s`,
                            animationDuration: `${l.duration}s`,
                            transform: `scale(${l.scale})`,
                        }}
                        title="Click to release golden Diwali stardust!"
                    >
                        <svg width="40" height="54" viewBox="0 0 40 54" style={{ overflow: 'visible', filter: `drop-shadow(0 4px 12px ${l.spec.glow})` }}>
                            {/* Lantern Paper Body */}
                            <path d="M 6 12 C 6 6 34 6 34 12 L 30 42 C 30 46 10 46 10 42 Z" fill={l.spec.color} opacity="0.88" />
                            {/* Inner Golden Lamp Flame */}
                            <ellipse cx="20" cy="38" rx="5" ry="6" fill="#fef08a" className="animate-pulse" />
                            <circle cx="20" cy="38" r="8" fill="#f59e0b" opacity="0.4" />
                            {/* Bamboo Ribs */}
                            <ellipse cx="20" cy="12" rx="14" ry="4" fill="none" stroke="#78350f" strokeWidth="1" />
                            <ellipse cx="20" cy="27" rx="13" ry="3.5" fill="none" stroke="#78350f" strokeWidth="0.8" opacity="0.6" />
                            <ellipse cx="20" cy="42" rx="10" ry="3" fill="none" stroke="#78350f" strokeWidth="1" />
                            {/* Hanging Tassels */}
                            <line x1="14" y1="44" x2="14" y2="52" stroke="#fbbf24" strokeWidth="1" />
                            <line x1="20" y1="44" x2="20" y2="54" stroke="#fbbf24" strokeWidth="1" />
                            <line x1="26" y1="44" x2="26" y2="52" stroke="#fbbf24" strokeWidth="1" />
                        </svg>
                    </div>
                );
            })}

            {/* Bottom Golden Rangoli Warmth */}
            <div className="fixed bottom-0 left-0 right-0 h-36 bg-gradient-to-t from-amber-950/40 via-red-950/15 to-transparent pointer-events-none z-[25]" />
        </div>
    );
};

export default FloatingSkyLanterns;
